import axios, {AxiosResponse} from 'axios';

export function setUserItem(key: string, data: object | string): Promise<AxiosResponse<void>> {
    return axios.post(`settings/user/${key}`, data);
}

export function getUserItem<T>(key: string): Promise<AxiosResponse<T>> {
    return axios.get(`settings/user/${key}`);
}

export function setChannelItem(key: string, data: object | string, channelName: string): Promise<AxiosResponse<void>> {
    return axios.post(`settings/channel/${channelName}/${key}`, data);
}

export function getChannelItem<T>(key: string, channelName: string): Promise<AxiosResponse<T>> {
    return axios.get(`settings/channel/${channelName}/${key}`);
}

export function getSkipSlopeSetting(): Promise<AxiosResponse<boolean>> {
    return axios.get(`settings/config/boolean/skipSlopes`);
}



// WEBPACK FOOTER //
// ./src/storage/SettingsAPI.ts